export default __webpack_public_path__ + "static/media/backgroundmobile.6da6e8d1.png";